export default "__VITE_ASSET__BvPXMbNT__"